'use strict';

var lodash = require('lodash');
var validator = require('validator');
var y = require('yup');
var ipAddress_utils = require('../ipAddress/ipAddress.utils.js');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const { convertToIpParts } = ipAddress_utils.ipUtils();
const name = 'ipAddressRange';
const IP_ADDRESS_RANGE_MIN_ERROR_KEY = 'invalidIpAddressMinRange';
const IP_ADDRESS_RANGE_MAX_ERROR_KEY = 'invalidIpAddressMaxRange';
const IP_ADDRESS_RANGE_ERROR_KEY = 'invalidIpAddressRange';
/**
 * Checks if the min ip address is less than the max ip address.
 */ const isMinIpLessThanMaxIp = (minIp, maxIp)=>{
    const minIpParts = convertToIpParts(minIp);
    const maxIpParts = convertToIpParts(maxIp);
    return(// compare the first value
    minIpParts[0] < maxIpParts[0] || // the first values should be equal and the second min ip value should be less than the second max ip value
    minIpParts[0] === maxIpParts[0] && minIpParts[1] < maxIpParts[1] || // the first and the second values should be equal, and the third min ip value should be less than the third max ip value
    minIpParts[0] === maxIpParts[0] && minIpParts[1] === maxIpParts[1] && minIpParts[2] < maxIpParts[2] || // the first, the second, and third values should be equal, and the fourth min ip value should be less than the max fourth ip value
    minIpParts[0] === maxIpParts[0] && minIpParts[1] === maxIpParts[1] && minIpParts[2] === maxIpParts[2] && minIpParts[3] < maxIpParts[3]);
};
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? IP_ADDRESS_RANGE_ERROR_KEY
        },
        test: (_value, context)=>{
            const minIp = lodash.get(context.parent, options?.minIpKey ?? 'minIp', '');
            const maxIp = lodash.get(context.parent, options?.maxIpKey ?? 'maxIp', '');
            if (!minIp || !maxIp) {
                return true;
            }
            // Validate min ip address
            if (!validator.isIP(minIp, '4')) {
                return context.createError({
                    message: IP_ADDRESS_RANGE_MIN_ERROR_KEY
                });
            }
            // Validate max ip address
            if (!validator.isIP(maxIp, '4')) {
                return context.createError({
                    message: IP_ADDRESS_RANGE_MAX_ERROR_KEY
                });
            }
            // Validate min ip address is less than max ip address
            return isMinIpLessThanMaxIp(minIp, maxIp);
        }
    });
});

exports.IP_ADDRESS_RANGE_ERROR_KEY = IP_ADDRESS_RANGE_ERROR_KEY;
exports.IP_ADDRESS_RANGE_MAX_ERROR_KEY = IP_ADDRESS_RANGE_MAX_ERROR_KEY;
exports.IP_ADDRESS_RANGE_MIN_ERROR_KEY = IP_ADDRESS_RANGE_MIN_ERROR_KEY;
//# sourceMappingURL=ipAddressRange.js.map
